import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Supprimer tous les tokens et données utilisateur
    localStorage.removeItem('authToken');
    localStorage.removeItem('memberToken');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('currentUser');
    
    // Rediriger vers la page d'accueil après 1 seconde
    setTimeout(() => {
      navigate('/');
    }, 1000);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4" style={{ borderColor: 'rgb(196, 150, 96)' }}></div>
        <h2 className="text-xl font-semibold mb-2" style={{ color: 'rgb(196, 150, 96)' }}>Déconnexion en cours...</h2>
        <p className="text-gray-600">Vous allez être redirigé vers la page d'accueil</p>
      </div>
    </div>
  );
};

export default Logout;
